import React, {Component} from 'react'
import Link from 'gatsby-link'
import FlagIcon from '../components/flagicon';
import axios from 'axios'
import moment from 'moment'
import { Alert } from "reactstrap";

import { findCountry } from "../components/helpers/countries";

var worldjson = require('../../node_modules/world-countries/dist/countries.json');


export default class ActualGame extends Component {

  constructor(props) {
    super(props) 

    this.state = {
      home_team_country: '',
      away_team_country: '',
      home_team_name: '',
      away_team_name: '',
      home_team_goals: '',
      away_team_goals: '',
      updated: '',
      nogame: '',
      home_team_events: [],
      away_team_events: [],
      time: '',
      home_team_country2: '',
      away_team_country2: '',
      home_team_name2: '',
      away_team_name2: '',
      home_team_goals2: '',
      away_team_goals2: '',
      updated2: '',
      nogame2: '',
      home_team_events2: [],
      away_team_events2: [],
      time2: ''
    }
    
    this.handleClick = this.handleClick.bind(this)

  }

  startTime(datetime) {
    return moment(datetime).format('HH:mm').toString();
  }

  componentDidMount() {
    this.handleClick();
    this.interval = setInterval(() => this.handleClick(), 60000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  searchCountryName(code) {
    for (var i = 0; i < worldjson.length; i++) {
      if (worldjson[i].cca2 == code.toUpperCase()) {
          return worldjson[i].translations.deu.common;
      }
      
  }
  }

  handleClick () {
    axios.get('https://world-cup-json.herokuapp.com/matches/current')
    .then(response => {
      console.log(response);
      if (response.data.length != 0) { 
        this.setState({
          home_team_country: response.data[0].home_team.code,
          home_team_goals: response.data[0].home_team.goals,
          away_team_country: response.data[0].away_team.code,
          away_team_goals: response.data[0].away_team.goals,
          venue: response.data[0].venue,
          last_updated: response.data[0].last_score_update_at,
          updated: true,
          updated2: false,
          nogame: false,
          home_team_name: response.data[0].home_team.country,
          away_team_name: response.data[0].away_team.country,
          time: response.data[0].time,

          // home_team_country2: response.data[1].home_team.code,
          // home_team_goals2: response.data[1].home_team.goals,
          // away_team_country2: response.data[1].away_team.code,
          // away_team_goals2: response.data[1].away_team.goals,
          // venue2: response.data[1].venue,
          // last_updated2: response.data[1].last_score_update_at,
          // updated2: true,
          // nogame2: false,
          // home_team_name2: response.data[1].home_team.country,
          // away_team_name2: response.data[1].away_team.country,
          // time2: response.data[1].time
        })
        if (response.data[0].home_team_events) {
          this.setState(
            {
            home_team_events: response.data[0].home_team_events
            }
          )
        }

        // if (response.data[1].home_team_events) {
        //   this.setState(
        //     {
        //     home_team_events2: response.data[1].home_team_events
        //     }
        //   )
        // }

        if (response.data[0].away_team_events) {
          this.setState({
            away_team_events: response.data[0].away_team_events
          })
        }

        // if (response.data[1].away_team_events) {
        //   this.setState({
        //     away_team_events2: response.data[1].away_team_events
        //   })
        // }
      } else {
        this.setState({
          nogame: true
        })
      }


    } )

  }

  emojiEvents (event) {
    switch (event) {
      case 'goal':
        return String.fromCodePoint(parseInt('26BD', 16)) + '\u{1F945}';
        break;
      case 'goal-penalty':
        return  String.fromCodePoint(parseInt('26BD', 16)) + '\u{1F945}';
        break;
      case 'goal-own':
        return  String.fromCodePoint(parseInt('26BD', 16)) + '\u{1F945}' + '\u{1F926}';
        break;
      case 'substitution-in':
        return String.fromCodePoint(parseInt('2B05', 16)) + String.fromCodePoint(parseInt('1F3C3', 16));
        break;
      case 'substitution-out':
        return String.fromCodePoint(parseInt('27A1', 16))  + String.fromCodePoint(parseInt('1F3C3', 16));
        break;
      case 'yellow-card':
        return String.fromCodePoint(parseInt('1F4D2', 16));
        break; 
      case 'red-card':
        return String.fromCodePoint(parseInt('1F4D5', 16));
        break; 
      default:
        return event
        break;
    }
  }

  render () {
    return (
      <div>
    <div>
      <h1>Aktuelles Spiel</h1>
      {this.state.updated && 
      <p>Letztes update um: {this.startTime(this.state.last_updated)}</p>
      }
      {this.state.nogame && 
      <Alert color="warning">Aktuell kein Spiel!</Alert>
    }
      
      

      {/* <div className="button__container">
        <button className="button" onClick={this.handleClick}>aktualisieren</button>
      </div> */}


      <p className="game__overview">
      
      {this.state.updated ? <FlagIcon code={findCountry(this.state.home_team_country)} size="5x" /> : null}
      
      {this.state.updated ? <span className="game__goals">{this.state.home_team_goals}:{this.state.away_team_goals}</span> : null}
      
      {this.state.updated ? <FlagIcon code={findCountry(this.state.away_team_country)} size="5x" /> : null}
      </p>

      {this.state.updated ? <p className="game__overview">{this.searchCountryName(findCountry(this.state.home_team_country))} vs {this.searchCountryName(findCountry(this.state.away_team_country))}</p> : null }

      {this.state.updated ? <p className="game__overview">{this.state.time} Spielminute</p> : null}

      <p className="game__overview">
      {this.state.updated ? this.state.venue  : null}
      </p>

      {this.state.home_team_events.length > 0 ? <p className="game__events">Aktivitäten {this.searchCountryName(findCountry(this.state.home_team_country))}:</p> : null}
      <p>{this.state.home_team_events.map((event,i) => {
        return (
        <p key={i}><span className="emoji__events">{this.emojiEvents(event.type_of_event)}</span> - {event.player} in Minute: {event.time}</p>
        )
      })}</p>

      {this.state.away_team_events.length > 0 ? <p className="game__events">Aktivitäten {this.searchCountryName(findCountry(this.state.away_team_country))}:</p> : null}
      <p>{this.state.away_team_events.map((event,i) => {
        return (
        <p key={i}><span className="emoji__events">{this.emojiEvents(event.type_of_event)}</span> - {event.player} in Minute: {event.time}</p>
        )
      })}</p>
  
    </div>

<div>
{this.state.updated2 && 
<div>
<h1>Aktuelles zweites Spiel</h1>
<p>Letztes update um: {this.startTime(this.state.last_updated)}</p>
</div>
}



{/* <div className="button__container">
  <button className="button" onClick={this.handleClick}>aktualisieren</button>
</div> */}


<p className="game__overview">

{this.state.updated2 ? <FlagIcon code={findCountry(this.state.home_team_country2)} size="5x" /> : null}

{this.state.updated2 ? <span className="game__goals">{this.state.home_team_goals2}:{this.state.away_team_goals2}</span> : null}

{this.state.updated2 ? <FlagIcon code={findCountry(this.state.away_team_country2)} size="5x" /> : null}
</p>

{this.state.updated2 ? <p className="game__overview">{this.searchCountryName(findCountry(this.state.home_team_country2))} vs {this.searchCountryName(findCountry(this.state.away_team_country2))}</p> : null }

{this.state.updated2 ? <p className="game__overview">{this.state.time2} Spielminute</p> : null}

<p className="game__overview">
{this.state.updated2 ? this.state.venue2  : null}
</p>

{this.state.home_team_events2.length > 0 ? <p className="game__events">Aktivitäten {this.searchCountryName(findCountry(this.state.home_team_country2))}:</p> : null}
<p>{this.state.home_team_events2.map((event,i) => {
  return (
  <p key={i}><span className="emoji__events">{this.emojiEvents(event.type_of_event)}</span> - {event.player} in Minute: {event.time}</p>
  )
})}</p>

{this.state.away_team_events2.length > 0 ? <p className="game__events">Aktivitäten {this.searchCountryName(findCountry(this.state.away_team_country2))}:</p> : null}
<p>{this.state.away_team_events2.map((event,i) => {
  return (
  <p key={i}><span className="emoji__events">{this.emojiEvents(event.type_of_event)}</span> - {event.player} in Minute: {event.time}</p>
  )
})}</p>

</div>
</div>
)
  
  }
}

// export default ActualGame



// WEBPACK FOOTER //
// ./src/pages/actualgame.js